import React from 'react';
import { PlusIcon } from 'lucide-react';
import { contentFaqs } from '../../data/kit';
import { offer } from '../../data/offer';
import { PendingNote } from '../ui/PendingNote';
import { Highlight, SectionHeading } from '../ui/SectionHeading';
type Faq = {
  q: string;
  a: React.ReactNode;
};
export function FaqSection() {
  const commercialFaqs: Faq[] = [{
    q: 'How do I receive it, and for how long do I have access?',
    a: <>
          After purchase you download the PDF.{' '}
          {offer.accessDuration ? `Access: ${offer.accessDuration}.` : <PendingNote data-id="element-47" data-mp="gzeaasi8wk8o">Access duration</PendingNote>}
        </>
  }, {
    q: 'How can I pay?',
    a: `${offer.paymentNote}${offer.paymentMethods.length ? ` Accepted: ${offer.paymentMethods.join(', ')}.` : ''}`
  }, {
    q: 'Is there a guarantee?',
    a: offer.guaranteeTerms ? offer.guaranteeTerms : <PendingNote data-id="element-48" data-mp="1nfzvq9eq9v69">Exact guarantee terms</PendingNote>
  }];
  const faqs: Faq[] = [...contentFaqs, ...commercialFaqs];
  return <section className="bg-cream py-16 sm:py-24" data-id="element-49" data-mp="ht7i0n32hnxc">
      <div className="mx-auto max-w-[860px] px-5 sm:px-8" data-id="element-50" data-mp="msk95k0z1h5q">
        <SectionHeading title={<>
              Frequently asked <Highlight data-id="element-52" data-mp="rt842gsbmi58">questions</Highlight>
            </>} data-id="element-51" data-mp="mqzeluenpy7v" />
        <div className="mt-10 grid gap-3" data-id="element-53" data-mp="vts17kcw9lrd">
          {faqs.map(faq => <details key={faq.q} className="group rounded-2xl border border-line bg-white px-5 shadow-sm sm:px-7" data-id="element-54" data-mp="3v8vsjech053o">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-5 py-5 text-[17px] font-bold text-petrol" data-id="element-55" data-mp="41jayy7odpn8">
                {faq.q}
                <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-mint text-teal transition-transform duration-200 ease-out group-open:rotate-45" data-id="element-56" data-mp="cumiyqzjxaah">
                  <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="3chvxbvedtz1y" />
                </span>
              </summary>
              <div className="pb-6 text-[15px] leading-relaxed text-slate" data-id="element-58" data-mp="3ghmy8rxmhvk7">{faq.a}</div>
            </details>)}
        </div>
      </div>
    </section>;
}